export default function Line() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.289"
      height="39"
      viewBox="0 0 29.289 39"
    >
      <g id="Group_5" data-name="Group 5" transform="translate(1.5 1.5)">
        <g id="Group_2" data-name="Group 2">
          <g id="Group" transform="translate(2 17)">
            <path
              id="Path_6"
              data-name="Path 6"
              d="M0,0,11.411,11.411,22.822,0"
              fill="none"
              stroke="#000"
              strokeMiterlimit={'10'}
              strokeWidth={'3'}
            />
          </g>
          <path
            id="Line_4_Copy"
            data-name="Line 4 Copy"
            d="M0,0V26.289"
            transform="translate(13)"
            fill="none"
            stroke="#000"
            strokeLinecap={'square'}
            strokeMiterlimit={'10'}
            strokeWidth={'3'}
          />
          <path
            id="Line_4_Copy_2"
            data-name="Line 4 Copy 2"
            d="M26.289,0H0"
            transform="translate(0 36)"
            fill="none"
            stroke="#000"
            strokeLinecap={'square'}
            strokeMiterlimit={'10'}
            strokeWidth={'3'}
          />
        </g>
      </g>
    </svg>
  )
}
